import EventService from "service/event/EventService";

import { CC_V2_REFRESH } from "../chiefComplaints/events";
import { DX_V2_REFRESH } from "../diagnosis/events";
import { MED_V2_REFRESH } from "../medicines/events";
import { HOSP_V2_REFRESH } from "../hospitalisation/events";
import { LI_V2_REFRESH } from "../labInvestigations/events";
import { ALG_V2_REFRESH } from "../allergies/events";
import { FAM_V2_REFRESH } from "../familyHistory/events";
import { ADD_V2_REFRESH } from "../addictions/events";
import { ACT_V2_REFRESH } from "../physicalActivity/events";
import { ANTH_V2_REFRESH } from "../anthropometric/events";
import { DS_V2_REFRESH as DAILY_SCHEDULE_REFRESH } from "../dailySchedule/events";
import { DS_V2_REFRESH as DRUG_SCHEDULE_REFRESH } from "../drugSchedule/events";
import { FP_V2_REFRESH } from "../foodPreference/events";
import { PD_V2_REFRESH } from "../patientDetails/events";

// Backend section-key → standalone section's REFRESH event.
//
// Emitted by AiTranscriptModal.saveSection right after a successful
// section save, so the standalone tables under the patient page
// re-fetch as soon as the transcript modal closes — reviewer never
// has to hit browser refresh to see what they just approved.
//
// Two sections happen to share the identifier `DS_V2_REFRESH` inside
// their respective events.js (dailySchedule + drugSchedule) — the
// underlying event strings differ, so they're aliased here.
const SECTION_TO_REFRESH_EVENT = {
  chief_complaints:   CC_V2_REFRESH,
  diagnosis:          DX_V2_REFRESH,
  medicines:          MED_V2_REFRESH,
  hospitalisation:    HOSP_V2_REFRESH,
  lab_investigations: LI_V2_REFRESH,
  allergies:          ALG_V2_REFRESH,
  family_history:     FAM_V2_REFRESH,
  addictions:         ADD_V2_REFRESH,
  activity:           ACT_V2_REFRESH,
  anthropometric:     ANTH_V2_REFRESH,
  daily_schedule:     DAILY_SCHEDULE_REFRESH,
  drug_schedule:      DRUG_SCHEDULE_REFRESH,
  food_preferences:   FP_V2_REFRESH,
  patient_details:    PD_V2_REFRESH,
};

export function emitSectionRefresh(section) {
  const evt = SECTION_TO_REFRESH_EVENT[section];
  if (evt) EventService.emit(evt);
}

export default SECTION_TO_REFRESH_EVENT;
